module.exports = __webpack_public_path__ + "img/dth.3345d70c.svg";